import React, { Component } from "react";
import propTypes from "prop-types";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";

let counter = 0;

export default class extends Component {
  static propTypes = {
    time: propTypes.string.isRequired,
    addAction: propTypes.func.isRequired
  };

  state = {
    popoverIsOpen: false
  };

  componentDidMount() {
    const { time } = this.props;
    const [hours, minutes] = time.split(":").map(Number);
    const dtBegin = new Date();
    dtBegin.setHours(hours, minutes);
    const dtEnd = new Date();
    dtEnd.setHours(hours, minutes + 30);
    this.times = [];
    do {
      const m = dtBegin.getMinutes();
      this.times.push(`${m < 10 ? 0 : ""}${m}`);
      dtBegin.setMinutes(m + 5);
    } while (
      dtBegin.getHours() < dtEnd.getHours() ||
      dtBegin.getMinutes() < dtEnd.getMinutes() || 
      (dtBegin.getHours() !== 0 && dtEnd.getHours() === 0)
    );
  }

  getId() {
    if (!this.id) {
      this.id = `time-item-${counter++}`;
    }
    return this.id;
  }

  togglePopover = () => {
    this.setState({ popoverIsOpen: !this.state.popoverIsOpen });
  };

  showPopover = () => {
    if (this._hidePopoverTimeout) {
      clearTimeout(this._hidePopoverTimeout);
      this._hidePopoverTimeout = null;
    } else {
      this.setState({ popoverIsOpen: true });
    }
  };

  hidePopover = () => {
    this._hidePopoverTimeout = setTimeout(() => {
      this.setState({ popoverIsOpen: false });
      clearTimeout(this._hidePopoverTimeout);
      this._hidePopoverTimeout = null;
    }, 50);
  };

  render() {
    const { popoverIsOpen } = this.state;
    const { time, addAction } = this.props;
    const [hours] = time.split(":");
    return (

      <div
        className="secondary"
        title={time}
        id={this.getId()}
        onClick={() => addAction(time)}
        onMouseOver={this.showPopover} onMouseLeave={this.hidePopover}
      >
        {time}
        <Popover
          title=""
          placement="bottom"
          onMouseOver={this.showPopover}
          onMouseLeave={this.hidePopover}
          isOpen={popoverIsOpen}
          target={`#${this.getId()}`}
          toggle={this.togglePopover}
        >
          <PopoverHeader className="popoverHeader">Точное время</PopoverHeader>

          <PopoverBody className="popover-body">
            {(this.times || []).map((minutes, idx) => (
              <div
                key={idx}
                className="button-popover office-add-session__time-item__part"
                onClick={() => addAction(`${hours}:${minutes}`)}
                title={`${hours}:${minutes}`}
              >
                {minutes}
              </div>
            ))}
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/schedule/_formTimeItem.jsx